const TextComponent = (props) => {
    return <div className="center">
        <p className="blockquote">{props.label}</p>
    </div>
}

export default TextComponent;